import React from 'react';
export const CityDasboardLegend = () => {
  return (
    <div>
      <div style={{ display: 'inline-block' }}>
        <div className='rectangle' style={{ backgroundColor: '#daef8f' }}></div>
        &nbsp;
        <p style={{ display: 'inline-block' }}> Low</p> &nbsp;
      </div>
      <div style={{ display: 'inline-block' }}>
        <div className='rectangle' style={{ backgroundColor: '#ffe80f' }}></div>
        &nbsp;
        <p style={{ display: 'inline-block' }}> Medium</p> &nbsp;
      </div>
      <div style={{ display: 'inline-block' }}>
        <div className='rectangle' style={{ backgroundColor: '#ffd9d5' }}></div>
        &nbsp;
        <p style={{ display: 'inline-block' }}> High</p> &nbsp;
      </div>
    </div>
  );
};

export const PopUpData = (props) => {
  return (
    <div>
      {props.someData == 'storeData' ? (
        <>
          <table
            className='table table-bordered table-hover table-striped '
            style={{
              borderCollapse: 'collapse',
            }}
          >
            <thead
              className=''
              style={{
                background: '#3c8dbc',
                color: '#fff',
                textAlign: 'center',
              }}
            >
              <tr>
                <th>Risk Bar</th>
                <th>Low Risk</th>
                <th>Medium Risk</th>
                <th>High Risk</th>
              </tr>
            </thead>
            <tbody
              style={{
                textAlign: 'center',
              }}
            >
              <tr>
                <td>SOD</td>
                <td className={'greenColorString'}>{'> 90'}</td>
                <td className={'orangeColorString'}>80-90</td>
                <td className={'redColorString'}>{'< 80'}</td>
              </tr>

              <tr>
                <td>NC- High priority</td>
                <td className={'greenColorString'}>{'< 5'}</td>
                <td className={'orangeColorString'}>5-10</td>
                <td className={'redColorString'}>{'> 10'}</td>
              </tr>
              <tr>
                <td>Flows</td>
                <td className={'greenColorString'}>{'> 85'}</td>
                <td className={'orangeColorString'}>70-85</td>
                <td className={'redColorString'}>{'< 70'}</td>
              </tr>
              <tr>
                <td>BSU</td>
                <td className={'greenColorString'}>{'> 90'}</td>
                <td className={'orangeColorString'}>80-90</td>
                <td className={'redColorString'}>{'< 80'}</td>
              </tr>
              <tr>
                <td>Open Incidents</td>
                <td className={'greenColorString'}>{'1'}</td>
                <td className={'orangeColorString'}>2-3</td>
                <td className={'redColorString'}>{'> 3'}</td>
              </tr>
            </tbody>
          </table>
        </>
      ) : (
        ''
      )}
    </div>
  );
};
export const PopUpData1 = (props) => {
  return (
    <div>
      {props.someData == 'trainingData' ? (
        <>
          <table
            className='table table-bordered table-hover table-striped '
            style={{
              borderCollapse: 'collapse',
            }}
          >
            <thead
              className=''
              style={{
                background: '#3c8dbc',
                color: '#fff',
                textAlign: 'center',
              }}
            >
              <tr>
                <th>Training</th>
                <th>Low Risk</th>
                <th>Medium Risk</th>
                <th>High Risk</th>
              </tr>
            </thead>
            <tbody
              style={{
                textAlign: 'center',
              }}
            >
              <tr>
                <td>INDUCTION </td>
                <td className={'greenColorString'}>{'100'}</td>
                <td className={'orangeColorString'}>95-99</td>
                <td className={'redColorString'}>{'< 95'}</td>
              </tr>

              <tr>
                <td>FAT AND FRT</td>
                <td className={'greenColorString'}>{'80-100'}</td>
                <td className={'orangeColorString'}>70-80</td>
                <td className={'redColorString'}>{'< 70'}</td>
              </tr>
              <tr>
                <td>DM Validation</td>
                <td className={'greenColorString'}>{'100'}</td>
                <td className={'orangeColorString'}>90-99</td>
                <td className={'redColorString'}>{'< 90'}</td>
              </tr>
              {/* <tr>
                <td>DM Revalidation</td>
                <td className={'greenColorString'}>{'100'}</td>
                <td className={'orangeColorString'}>90-99</td>
                <td className={'redColorString'}>{'< 90'}</td>
              </tr> */}
              <tr>
                <td>Flows Training</td>
                <td className={'greenColorString'}>{'80-100'}</td>
                <td className={'orangeColorString'}> 70-80</td>
                <td className={'redColorString'}>{'< 70'}</td>
              </tr>
            </tbody>
          </table>
        </>
      ) : (
        ''
      )}
    </div>
  );
};
export const PopUpData2 = (props) => {
  return (
    <div>
        {props.someData == 'storeData' && 
          <table
            className='table table-bordered table-hover table-striped '
            style={{
              borderCollapse: 'collapse',
            }}
          >
            <thead
              className=''
              style={{
                background: '#3c8dbc',
                color: '#fff',
                textAlign: 'center',
              }}
            >
              <tr>
                <th>Risk Bar</th>
                <th>Low Risk</th>
                <th>Medium Risk</th>
                <th>High Risk</th>
              </tr>
            </thead>
            <tbody
              style={{
                textAlign: 'center',
              }}
            >
              <tr>
                <td>SOD</td>
                <td className={'greenColorString'}>{'> 90'}</td>
                <td className={'orangeColorString'}>80-90</td>
                <td className={'redColorString'}>{'< 80'}</td>
              </tr>
              <tr>
                <td>NC- High priority</td>
                <td className={'greenColorString'}>{'< 5'}</td>
                <td className={'orangeColorString'}>5-10</td>
                <td className={'redColorString'}>{'> 10'}</td>
              </tr>
              <tr>
                <td>Flows</td>
                <td className={'greenColorString'}>{'> 85'}</td>
                <td className={'orangeColorString'}>70-85</td>
                <td className={'redColorString'}>{'< 70'}</td>
              </tr>
              <tr>
                <td>BSU</td>
                <td className={'greenColorString'}>{'> 90'}</td>
                <td className={'orangeColorString'}>80-90</td>
                <td className={'redColorString'}>{'< 80'}</td>
              </tr>
              <tr>
                <td>Open Incidents</td>
                <td className={'greenColorString'}>{'1'}</td>
                <td className={'orangeColorString'}>2-3</td>
                <td className={'redColorString'}>{'> 3'}</td>
              </tr>
              <tr>
                <td>INDUCTION </td>
                <td className={'greenColorString'}>{'100'}</td>
                <td className={'orangeColorString'}>95-99</td>
                <td className={'redColorString'}>{'< 95'}</td>
              </tr>
              <tr>
                <td>FAT AND FRT</td>
                <td className={'greenColorString'}>{'80-100'}</td>
                <td className={'orangeColorString'}>70-80</td>
                <td className={'redColorString'}>{'< 70'}</td>
              </tr>
              {/* <tr>
                <td>DM Validation</td>
                <td className={'greenColorString'}>{'100'}</td>
                <td className={'orangeColorString'}>90-99</td>
                <td className={'redColorString'}>{'< 90'}</td>
              </tr>
              <tr>
                <td>Flows Training</td>
                <td className={'greenColorString'}>{'80-100'}</td>
                <td className={'orangeColorString'}> 70-80</td>
                <td className={'redColorString'}>{'< 70'}</td>
              </tr> */}
            </tbody>
          </table>}
    </div>
  );
};
